export default "__VITE_ASSET__B2Ysw9vr__"